<template>
  <v-container class="select-region">
    <span class="fibl-headline">{{$t('projectRegion.headline') }}</span>
    <p>{{$t('projectRegion.countryText')}}</p>
    <v-row class="countries">
      <template v-for="(value, idx) in countries">
        <v-btn
          fab
          depressed
          icon
          :key="idx"
          @click="
            selectCountry(value.title);
            active(value);
          "
          :class="{ inactive: value.inactive, country_flag: true }"
        >
          <v-img :src="value.icon" class="country_flag"/>
        </v-btn>
      </template>
    </v-row>
    <div v-show="this.country !== null && this.country.title !== 'HU'">
      <p>{{ $t('projectRegion.regionText') }}</p>
        <v-combobox
          class="region-combobox"
          :items="regions"
          :item-text="(r) => r['name_'+$i18n.locale]"
          v-model="selectedRegions"
          @change="regionChanged()"
          multiple
          label="Region"
          chips
        ></v-combobox>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      country: null,
      countries: [
        { title: "CH", icon: require("@/assets/ch_flag.svg"), inactive: true },
        { title: "DE", icon: require("@/assets/de_flag.svg"), inactive: true },
        { title: "DK", icon: require("@/assets/dk_flag.svg"), inactive: true },
        {
          title: "EST",
          icon: require("@/assets/est_flag.svg"),
          inactive: true,
        },
        { title: "HU", icon: require("@/assets/hun_flag.svg"), inactive: true },
      ],
      selectedRegions: null,
    };
  },

  computed: {
    ...mapGetters({
      regions: "regionsForSelectedCountry",
    }),

    regionNames() {
      return this.regions.map((r) => r['name_'+this.$i18n.locale]);
    },
  },

  methods: {
    selectCountry(country) {
      if (this.selectedRegions != null) {
        this.selectedRegions = null;
      }

      if(country === "HU") {
        this.selectedRegions = [{
          "countryCode": "HU",
          "id": "2d913a1f-dfaa-44e3-abc5-151d0eb09b16",
          "name_de": "Hungary",
          "name_en": "Hungary",
          "type": "country"
        }]
      this.regionChanged();
      } else {
        this.selectedRegions = [];
        this.$emit("changed", this.selectedRegions)
      }
      this.$store.commit("setCountry", country);
    },

    regionChanged() {
      this.$emit("changed", this.selectedRegions);
    },

    active(value) {
      if (!this.country) {
        this.country = value;
        this.country.inactive = !this.country.inactive;
      } else {
        this.country.inactive = !this.country.inactive;
        this.country = value;
        this.country.inactive = !this.country.inactive;
      }
    },
    
  },
};
</script>
<style>
.inactive {
  background-color: white;
  opacity: 0.6;
}
</style>
